import { useEffect, useState } from "react";
import Ad from "../components/Ad";
import ColdCaller from "../assets/images/cogs/sellbots/Cold_caller.png";
import Telemarketer from "../assets/images/cogs/sellbots/Telemarketer.png";
import NameDropper from "../assets/images/cogs/sellbots/Name_dropper.png";
import GladHander from "../assets/images/cogs/sellbots/Glad_hander.png";
import MoverShaker from "../assets/images/cogs/sellbots/Mover_and_shaker.png";
import TwoFace from "../assets/images/cogs/sellbots/Two_face.png";
import TheMingler from "../assets/images/cogs/sellbots/The_mingler.png";
import MrHollywood from "../assets/images/cogs/sellbots/Mr_hollywood.png";

import ShortChange from "../assets/images/cogs/cashbots/Short_change.png";
import PennyPincher from "../assets/images/cogs/cashbots/Penny_pincher.png";
import Tightwad from "../assets/images/cogs/cashbots/Tightwad.png";
import BeanCounter from "../assets/images/cogs/cashbots/Bean_counter.png";
import NumberCruncher from "../assets/images/cogs/cashbots/Number_cruncher.png";
import MoneyBags from "../assets/images/cogs/cashbots/Money_bags.png";
import LoanShark from "../assets/images/cogs/cashbots/Loan_shark.png";
import RobberBaron from "../assets/images/cogs/cashbots/Robber_baron.png";

import BottomFeeder from "../assets/images/cogs/lawbots/BottomFeeder2.png";
import Bloodsucker from "../assets/images/cogs/lawbots/Bloodsucker2.png";
import DoubleTalker from "../assets/images/cogs/lawbots/Doubletalker2.png";
import AmbulanceChaser from "../assets/images/cogs/lawbots/Ambulance_Chaser2.png";
import BackStabber from "../assets/images/cogs/lawbots/Backstabber2.png";
import SpinDoctor from "../assets/images/cogs/lawbots/Spindoctor2.png";
import LegalEagle from "../assets/images/cogs/lawbots/Legaleagle2.png";
import BigWig from "../assets/images/cogs/lawbots/Bigwig2.png";

import Flunky from "../assets/images/cogs/bossbots/Flunky2.png";
import PencilPusher from "../assets/images/cogs/bossbots/Pencilpusher2.png";
import Yesman from "../assets/images/cogs/bossbots/Yesman2.png";
import Micromanager from "../assets/images/cogs/bossbots/Micromanager2.png";
import Downsizer from "../assets/images/cogs/bossbots/Downsizer2.png";
import HeadHunter from "../assets/images/cogs/bossbots/Headhunter2.png";
import CorporateRaider from "../assets/images/cogs/bossbots/Corporate_Raider2.png";
import TheBigCheese from "../assets/images/cogs/bossbots/Thebigcheese2.png";

const INVASIONS_API_URL = "https://www.toontownrewritten.com/api/invasions";
const AUTO_REFRESH_MS = 30000; // 30 seconds

function formatEpoch(epoch) {
    if (!epoch && epoch !== 0) return "Unknown";
    const date = new Date(epoch * 1000);
    if (Number.isNaN(date.getTime())) return "Unknown";
    return date.toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
    });
}

function normalizeCogName(rawType) {
    if (!rawType) return "";
    let name = rawType.toLowerCase();
    // Remove stray control characters that can appear in some names (e.g. Micro\u0003manager)
    name = Array.from(name)
        .filter((ch) => {
            const code = ch.charCodeAt(0);
            return !(code <= 31 || (code >= 127 && code <= 159));
        })
        .join("");
    // Remove Version 2.0 prefix and (Skelecog) suffix when present
    name = name.replace(/^version 2\.0\s+/i, "");
    name = name.replace(/\s*\(skelecog\)\s*/i, "");
    return name.trim();
}

const COG_IMAGES = {
    // Sellbots
    "cold caller": ColdCaller,
    "telemarketer": Telemarketer,
    "name dropper": NameDropper,
    "glad hander": GladHander,
    "mover & shaker": MoverShaker,
    "mover and shaker": MoverShaker,
    "two face": TwoFace,
    "two-face": TwoFace,
    "the mingler": TheMingler,
    "mr. hollywood": MrHollywood,

    // Cashbots
    "short change": ShortChange,
    "penny pincher": PennyPincher,
    "tightwad": Tightwad,
    "bean counter": BeanCounter,
    "number cruncher": NumberCruncher,
    "money bags": MoneyBags,
    "loan shark": LoanShark,
    "robber baron": RobberBaron,

    // Lawbots
    "bottom feeder": BottomFeeder,
    "bloodsucker": Bloodsucker,
    "double talker": DoubleTalker,
    "ambulance chaser": AmbulanceChaser,
    "back stabber": BackStabber,
    "spin doctor": SpinDoctor,
    "legal eagle": LegalEagle,
    "big wig": BigWig,

    // Bossbots
    "flunky": Flunky,
    "pencil pusher": PencilPusher,
    "yesman": Yesman,
    "yes man": Yesman,
    "micromanager": Micromanager,
    "micro manager": Micromanager,
    "downsizer": Downsizer,
    "head hunter": HeadHunter,
    "corporate raider": CorporateRaider,
    "the big cheese": TheBigCheese,
};

export default function Invasions() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const loadInvasions = () => {
        setLoading(true);
        setError(null);

        fetch(INVASIONS_API_URL, { cache: "no-store" })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to load invasions. Please try again.");
                }
                return response.json();
            })
            .then((json) => {
                if (json.error) {
                    throw new Error(json.error);
                }
                setData(json);
            })
            .catch((err) => {
                setError(err.message || "Something went wrong while loading invasions.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        loadInvasions();

        const id = setInterval(() => {
            loadInvasions();
        }, AUTO_REFRESH_MS);

        return () => clearInterval(id);
    }, []);

    const invasions = data && data.invasions ? Object.entries(data.invasions) : [];

    return (
        <div className="panel">
            <div className="panel-content">
                <h1>Invasion Tracker</h1>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div>
                        {data && data.lastUpdated && (
                            <p style={{ margin: 0 }}>
                                <strong>Last updated:</strong> {formatEpoch(data.lastUpdated)}
                            </p>
                        )}
                    </div>
                </div>

                {loading && !data && <p>Loading current invasions...</p>}

                {!loading && error && (
                    <p>
                        {error}
                    </p>
                )}

                {data && !loading && !error && invasions.length === 0 && (
                    <p>There are currently no active invasions.</p>
                )}

                {data && !error && invasions.length > 0 && (
                    <table>
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Cog</th>
                                <th>District</th>
                                <th>Progress</th>
                                <th>Start Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invasions.map(([district, invasion]) => {
                                const normalized = normalizeCogName(invasion.type);
                                const cogImage = COG_IMAGES[normalized];
                                return (
                                    <tr key={district}>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                            {cogImage && (
                                                <img
                                                    src={cogImage}
                                                    alt={invasion.type}
                                                    style={{
                                                        height: 40,
                                                        width: "auto",
                                                        maxWidth: 60,
                                                        borderRadius: 4,
                                                        objectFit: "contain",
                                                        display: "block",
                                                        margin: "0 auto",
                                                    }}
                                                />
                                            )}
                                        </td>
                                        <td>{invasion.type}</td>
                                        <td>{district}</td>
                                        <td>{invasion.progress}</td>
                                        <td>{formatEpoch(invasion.startTimestamp)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
                <br />
                <Ad dataAdSlot="8689384557" />
            </div>
        </div>
    );
}
